export default "__VITE_PUBLIC_ASSET__afb1587f__"